import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductItems } from '../../../../../../models/product/get-product-request';

@Component({
  selector: 'app-pricing-tab',
  templateUrl: './pricing-tab.component.html',
  styleUrls: ['./pricing-tab.component.scss']
})
export class PricingTabComponent implements OnInit {
  @Input() product: ProductItems | null = null;
  @Input() pricingFormGroup!: FormGroup;
  @Output() pricingDataChanged = new EventEmitter<any>();
  selectedVat: boolean = true;
  isEditable = false;
  displayPrice!: number;
  vatAmount: number = 0; // to allow computation when vat is disabled
  sellingPrice: number = 0; // to allow computation when vat is enabled
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    if (this.pricingFormGroup) {
      this.pricingFormGroup.get('DisplayedPrice')?.disable();
      this.setupFormValueChanges();
    }
  }

  private setupFormValueChanges(): void {
    this.pricingFormGroup.valueChanges.subscribe((data) => {
      //Reflect realtime calculation to Displayed Price field ex. Nan+1 = 1
      const vat: number = +`${
        this.pricingFormGroup.get('VatAmount')?.disabled ||
        isNaN(+`${data.VatAmount}`)
          ? this.vatAmount
          : data.VatAmount
      }`;

      // Reflect realtime calculation to Displayed Price field ex. 1+Nan = 1
      const sellingPrice: number = +`${
        isNaN(+`${data.VatAmount}`) && isNaN(+`${data.SellingPrice}`)
          ? this.sellingPrice
          : data.SellingPrice
      }`;

      this.displayPrice = vat + sellingPrice;

      // Formatting number
      this.pricingFormGroup.value.DisplayedPrice =
        this.displayPrice.toLocaleString();
    });
  }

  selectVat(): void {
    this.pricingFormGroup.get('IsVatable')?.setValue(this.selectedVat);
    if (this.selectedVat) {
      this.pricingFormGroup.get('VatAmount')?.enable();
    } else {
      this.pricingFormGroup.get('VatAmount')?.disable();
    }
  }

  addVat(): void {
    const vat: number = +`${this.pricingFormGroup.get('VatAmount')?.value}`;
    const sellingPrice: number = +`${
      this.pricingFormGroup.get('SellingPrice')?.value
    }`;
    this.displayPrice = vat + sellingPrice;
    this.pricingFormGroup
      .get('DisplayedPrice')
      ?.setValue(this.displayPrice.toString());
  }

  onSellingPriceChange(): void {
    this.sellingPrice = this.pricingFormGroup.get('SellingPrice')?.value || 0;
    this.emitPricingData();
  }

  onCostPriceChange(): void {
    // You can add profit calculation logic here if needed
    this.emitPricingData();
  }

  emitPricingData(): void {
    const pricingData = {
      CostPrice: this.pricingFormGroup.get('CostPrice')?.value || 0,
      SellingPrice: this.pricingFormGroup.get('SellingPrice')?.value || 0,
      IsVatable: this.pricingFormGroup.get('IsVatable')?.value || true,
      VatAmount: this.vatAmount,
      DisplayedPrice: this.displayPrice
    };
    this.pricingDataChanged.emit(pricingData);
  }
  // Method to get current pricing data (can be called from parent)
  getCurrentPricingData(): any {
    const pricingData = {
      CostPrice: this.pricingFormGroup.get('CostPrice')?.value || 0,
      SellingPrice: this.pricingFormGroup.get('SellingPrice')?.value || 0,
      IsVatable: this.pricingFormGroup.get('IsVatable')?.value || true,
      VatAmount: this.vatAmount,
      DisplayedPrice: this.displayPrice
    };
    return pricingData;
  }
}
